(function($){
    $(document).ready(function() {
        function dedupeEventsIntro() {
            var views = document.querySelectorAll('[data-js="tribe-events-view"]');

            if (!views.length) {
                return;
            }

            Array.prototype.forEach.call(views, function(view) {
                var parent = view.parentNode;

                if (!parent) {
                    return;
                }

                var introBlocks = parent.querySelectorAll(':scope > .tribe-events-before-html');

                if (introBlocks.length <= 1) {
                    return;
                }

                Array.prototype.forEach.call(introBlocks, function(block, index) {
                    if (index === 0) {
                        return;
                    }

                    block.parentNode.removeChild(block);
                });
            });
        }

        dedupeEventsIntro();
        document.addEventListener('afterAjaxSuccess.tribeEvents', dedupeEventsIntro);
        document.addEventListener('DOMContentLoaded', dedupeEventsIntro);

        var observer = new MutationObserver(function() {
            dedupeEventsIntro();
        });

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    });
})(jQuery);
